import Modal from "../lib/modals";

document.querySelectorAll('.ModalAlert').forEach(el => {
  new Modal(el);
});
